import react, { useEffect, useState } from 'react'
import { FaPlus, FaSave, FaTimes } from 'react-icons/fa'
import { TipoVariacao, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasVermelho, classbtVermelho } from '../../Utils/Types'
import React from 'react'

type Props = {
    visible: boolean,
    loading: boolean,
    closeModal: () => void,
    saveData: (descricao: string, tipo: string) => void,
    tipoRegistro: TipoVariacao,
    titulo: string,
}

export const ModalCadVariacao = React.memo(({ visible, loading, closeModal, saveData, tipoRegistro, titulo }: Props) => {

    const [descricao, setDescricao] = useState("")
    const [tipo, setTipo] = useState("V")

    const handleDescricaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescricao(e.target.value)
    } 

    const handleChangeTipo = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTipo(e.target.value)
    }

    const handleSaveData = () => {
        saveData(descricao, tipo)
    }

    useEffect(() => {
        setTipo(tipoRegistro)
    }, [])

    useEffect(() => {

        if (visible) {

            let inputVariacao = document.querySelector('#tipoVariacao') as HTMLInputElement

            if (inputVariacao) {
                inputVariacao.checked = false
            }

            let tipoSubVariacao = document.querySelector('#tipoSubVariacao') as HTMLInputElement

            if (tipoSubVariacao) {
                tipoSubVariacao.checked = false
            }

            setDescricao("")
            setTipo("")
            let modal = document.getElementById("modal_cad_variacao")
            let modalContent = document.getElementById("modal_cad_variacao_content")
            const input = document.getElementById("modal_desc_variacao")

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-400px]')
                    modalContent.classList.add('mt-24')
                }
            }

            const timerOut = setTimeout(() => {
                if (input) {
                    input.focus()
                }

                clearTimeout(timerOut)
            }, 100)

        } else {

            let modal = document.getElementById("modal_cad_variacao")
            let modalContent = document.getElementById("modal_cad_variacao_content")

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-400px]')
                    modalContent.classList.remove('mt-24')
                }
            }
        }

    }, [visible])

    return (

        <div id="modal_cad_variacao" style={{ visibility: 'hidden', backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_cad_variacao_content" className={`relative flex flex-col w-[80%] sm:w-[60%] md:w-[40%] lg:w-[30%] 2xl:w-[20%] h-[200px] bg-white dark:bg-slate-600 rounded-lg mt-[-400px] transition-all duration-300 justify-center items-center`}>

                {/* Header */}
                <div className={`absolute top-0 w-full h-[50px] flex items-center border border-x-0 border-t-0 border-slate-200 dark:border-slate-500 px-4 space-x-2`}>
                    <FaPlus className={`w-6 h-6 text-blue-500 dark:text-blue-400`} />
                    <span className={`text-base font-semibold leading-6 text-slate-700 dark:text-white`}>Cadastro - {titulo}</span>
                </div>
                {/* Header */}

                {/* Body */}
                <div className={`absolute top-[50px] bottom-[60px] w-full p-4 flex items-center`}>

                    <div className={`h-auto w-full`}>

                        <div className={`relative w-full col-span-12 md:col-span-2`}>
                            <input id="modal_desc_variacao" className={`${classInput} ${classInputDark} `} type="text" inputMode='text' placeholder=" " maxLength={155} autoComplete='off' value={descricao} onChange={handleDescricaoChange} />
                            <label htmlFor="modal_desc_variacao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{titulo}</label>
                        </div>

                        {/*}<div className='flex items-center w-full my-2'>
                                <input name='tipoVariacao' id='tipoVariacao' className='h-4 w-4' type='radio' onChange={handleChangeTipo} value="V"/>
                                <label htmlFor="tipoVariacao" className='text-sm ml-1'>Variação</label>
                                <input name='tipoVariacao' id='tipoSubVariacao' className='h-4 w-4 ml-2' type='radio' value="S" onChange={handleChangeTipo}/>
                                <label  htmlFor="tipoSubVariacao" className='text-sm ml-1'>Sub Variação</label>
                            </div> {*/}
                    </div>

                </div>
                {/* Body */}

                {/* Footer */}
                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        onClick={closeModal}
                        className={`${classbtColunasVermelho} sm:max-w-[150px]`}>
                        CANCELAR
                    </button>

                    <button
                        onClick={handleSaveData}
                        className={`${classbtAzul} ${classBt} sm:max-w-[150px]`}>
                        {!loading && <FaSave size={"18px"} className={`mr-2`} />}
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? `SALVAR` : "AGUARDE"}
                    </button>

                </div>
                {/* Footer */}

            </div>

        </div>

    )

})